module.exports = __webpack_public_path__ + "static/img/9mLogin.eadbc3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/9mLogin.jpg
// module id = WTru
// module chunks = 1